module.exports = __webpack_public_path__ + "img/Mask Group 7@2x.png";